/** Created by azhou on 2018/7/24.*/
<template>
  <div class="text-left">
    <h5>1、使用者非个人化信息</h5>
    <p>
      我们将通过您的IP地址来收集非个人化的信息，例如您的浏览器性质、操作平台种类、给您提供接入服务的ISP的域名等，以优化在您计算机屏幕上显示的页面。通过收集上述信息，我们也进行客流量统计，从而改进网站的管理和服务。
    </p>
    <h5>2、个人资料</h5>
    <p>01：当您在本平台购买产品/服务或参与其它活动时，在您的同意及确认下，本平台将通过注册等形式要求您提供一些个人资料。这些个人资料包括姓名、性别、手机、通信地址、电子邮件地址等情况。</p>
    <p>02：请了解，在未经您同意及确认之前，本平台不会将您购买产品/服务或参与其它活动所提供的资料利用于其它目的。惟按下列第6条规定应政府及法律要求披露时不在此限。</p>
    <h5>3、信息安全</h5>
    <p>01：本平台将对您所提供的资料进行严格的管理及保护，本平台将使用相应的技术，防止您的个人资料丢失、被盗用或遭窜改。</p>
    <p>02：本平台在必要时委托专业技术人员代为对该类资料进行电脑处理，以符合专业分工时代的需求。如本平台将电脑处理之通知送达予您，而您未在通知规定的时间内主动明示反对，本平台将推定您已同意。惟在其后您仍然有权如下述第4.1.4条之规定，请求停止电脑处理。</p>
    <h5>4、用户权利</h5>
    <p>01：您对于自己的个人资料享有以下权利：</p>
    <p>（1）随时查询及请求阅览；</p>
    <p>（2）随时请求补充或更正；</p>
    <p>（3）随时请求删除；</p>
    <p>02：请求停止电脑处理及利用。</p>
    <p>03：针对以上权利，订单雨为您提供相关服务，您对此声明有任何疑问，请联系我们。</p>

    <h5>5、限制利用原则</h5>
    <p>本平台惟在符合下列条件之一，方对收集之个人资料进行必要范围以外之利用：</p>
    <p>01．已取得您的书面同意；</p>
    <p>02．为免除您在生命、身体或财产方面之急迫危险；</p>
    <p>03．为防止他人权益之重大危害；</p>
    <p>04．为增进公共利益，且无害于您的重大利益。</p>

    <h5>6、个人资料之披露</h5>
    <p>当政府机关依照法定程序要求本平台披露个人资料时，本平台将根据执法单位之要求或为公共安全之目的提供个人资料。在此情况下之任何披露，本平台均免责。</p>

    <h5>7、免责</h5>
    <p>除上述第6条规定属免责外，下列情况时本平台亦无需承担任何责任：</p>
    <p>（1）于您将用户密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露。</p>
    <p>（2）任何由于计算机问题、黑客政击、计算机病毒侵入或发作、因政府管制而造成的暂时性关闭等影响网络正常经营之不可抗力而造成的个人资料泄露、丢失、被盗用或被窜改等。</p>
    <p>（3）由于与本平台链接的其它网站所造成之个人资料泄露及由此而导致的任何法律争议和后果。</p>
    <p>本平台之保护隐私声明的修改及更新权均属于杭州订单雨络科技有限公司。</p>

    <h5>8、电子报</h5>
    <p>01：订阅电子报：当您注册成为订单雨会员时，本平台会主动帮您订阅微信公众号；若有特别活动时，本平台会发送相关活动内容给您（不定期）。</p>
    <p>02：订单雨从网站所取得之个人资料（如姓名、电子信箱），主要作为电子报的寄发所需，及其他必要性的订户数据分析。</p>
  </div>
</template>

<script>
  export default {
    data() {
      return {}
    },
    components: {}
  }
</script>
<style lang="scss" scoped>
  h5{font-weight: bold}
  p{ color: #aaa;}
</style>
